import { Fragment, ReactNode } from 'react';

import { Box } from 'components/Box';
import { ClientOnly } from 'containers/ClientOnly';

import { StyledSelectInput } from './Select.styled';
import { StyledSelect } from './StyledSelect';
import { formatOptionLabel } from './formatOptionLabel';

type Props = {
  id?: string;
  'aria-label'?: string;
  customCompare?: (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arg0: Record<string, any>,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arg1: Record<string, any>
  ) => boolean;
  disableGreyOnNull?: boolean;
  name?: string;
  label?: ReactNode;
  value?: string | null | undefined;
  options: Array<{
    value: string;
    label: string;
    description?: string;
    disabled?: boolean;
  }>;
  disabled?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (...args: Array<any>) => any;
  className?: string;
  isClearable?: boolean;
  isSearchable?: boolean;
  noMargin?: boolean;
  placeholder?: string;
  'data-qa-id'?: string;
};

export function Select({
  id,
  name,
  label,
  value,
  options,
  disabled,
  onChange,
  className,
  isClearable,
  isSearchable,
  ...props
}: Props) {
  const classNames = props['data-qa-id']
    ? [`qa-id-${props['data-qa-id']}`]
    : [];

  if (className) {
    classNames.push(className);
  }

  const Container = label ? 'label' : Fragment;
  return (
    <ClientOnly
      placeholder={
        <StyledSelectInput
          options={options}
          value={typeof value === 'string' ? value : ''}
          onChange={onChange}
          className={classNames.join(' ')}
        />
      }
    >
      <Container>
        {label && <Box display="none">{label}</Box>}
        <StyledSelect
          name={name}
          options={options}
          value={options.filter(({ value: v }) => v === value)}
          isDisabled={disabled}
          onChange={onChange}
          formatOptionLabel={formatOptionLabel}
          isSearchable={isSearchable}
          isClearable={isClearable || false}
          className={classNames.join(' ')}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </Container>
    </ClientOnly>
  );
}
